import { useState, useRef } from 'react';
import Popover from '@mui/material/Popover';
import InfoIcon from '../../assets/icons/InfoIcon';
import styles from './PartValidation.module.scss';
import ValidPartsDetailsPopup from './ValidPartsDetailsPopup';

const greenColor = '#49a47e';
const redColor = 'red';
const greyColor = '#7070708c';
const yellowColor = '#ffa222';

const ValidPartsDetailsPopover = ({ rowData }) => {
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const iconRef = useRef(null);

	const openPopup = () => setIsPopupOpen(true);
	const closePopup = () => setIsPopupOpen(false);

	return (
		<>
			<InfoIcon
				style={{
					color: greyColor,
				}}
				className={styles.infoIconStyle}
				ref={iconRef}
				onClick={openPopup}
			/>
			<Popover
				open={isPopupOpen}
				style={{ marginTop: '10px' }}
				anchorEl={iconRef.current}
				onClose={closePopup}
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'center',
					horizontal: 'left',
				}}
			>
				<ValidPartsDetailsPopup
					parts={rowData ?? []}
				/>
			</Popover>
		</>
	);
};

export default ValidPartsDetailsPopover;
